import { render } from "./AboutHeader.vue?vue&type=template&id=79c62fa9&scoped=true"
import script from "./AboutHeader.vue?vue&type=script&lang=js"
export * from "./AboutHeader.vue?vue&type=script&lang=js"

import "./AboutHeader.vue?vue&type=style&index=0&id=79c62fa9&scoped=true&lang=css"

import exportComponent from "D:\\boya_project\\boya_web_mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c62fa9"]])

export default __exports__